<template>
  <!-- download -->
  <v-list-item
    :class="{ 'pa-0': hasQualityAvailable }"
    :disabled="loading"
    @click="handleDownloadOriginal(video.backup, $event)"
  >
    <!-- has qualities available -->
    <template v-if="hasQualityAvailable">
      <v-menu v-model="showQualitiesMenu" left offset-x :transition="null">
        <!-- title -->
        <template v-slot:activator="{ on, attrs }">
          <v-list-item v-bind="attrs" v-on="on" dense class="pa-0 px-3">
            <v-list-item-avatar
              style="
                margin-left: -6px;
                height: 32px !important;
                margin-top: 0px !important;
                margin-bottom: 0px !important;
              "
            >
              <v-progress-circular
                v-if="loading"
                :size="18"
                width="2"
                color="gray"
                indeterminate
              />
              <v-icon v-else>mdi-download</v-icon>
            </v-list-item-avatar>
            <v-list-item-content
              :style="`margin-left: ${12 * (hasRecuo ? -1 : 1)}px`"
            >
              <v-list-item-title>
                {{
                  loading
                    ? $t('message.downloadingFiles')
                    : $t('message.download')
                }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action style="margin: 0px !important">
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>

        <!-- content::qualities-downloads -->
        <v-list dense>
          <!-- qualities -->
          <template v-for="(storageItem, index) in sizesList">
            <template v-if="storageItem.available">
              <v-list-item
                :key="`${storageItem.name}--${index}`"
                class="py-0"
                dense
                @click="handleDownloadQuality(storageItem)"
              >
                <v-list-item-title class="px-2">{{
                  storageItem.name
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </template>

          <!-- original -->
          <v-list-item
            class="py-0"
            dense
            @click="handleBackupDownload(video.backup, $event)"
          >
            <v-list-item-title class="px-2">
              <div class="d-flex align-center">
                <span :class="{ 'text--disabled': !video.backup }">
                  Backup original
                </span>
                <v-btn
                  v-if="(!video.backup || !fetchOnMount) && !loading"
                  icon
                  small
                  class="pa-0 ml-auto"
                  :class="{
                    helper__btn: !video.backup || (fetchOnMount && listFetched),
                  }"
                >
                  <v-icon v-if="!video.backup || (fetchOnMount && listFetched)"
                    >mdi-help</v-icon
                  >
                </v-btn>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <!-- don't have qualities available -->
    <template v-else>
      <v-list-item-icon
        :style="loading ? 'min-height:34px' : ''"
        :class="{
          'mr-3': hasRecuo,
          'd-flex align-center justify-center': loading,
        }"
        style="
          height: 32px !important;
          margin-top: 0px !important;
          margin-bottom: 0px !important;
        "
      >
        <v-progress-circular
          v-if="loading"
          :size="18"
          width="2"
          color="gray"
          indeterminate
        />
        <v-icon v-else class="pt-2">mdi-download</v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        <div class="d-flex align-center">
          <span>
            {{
              loading ? $t('message.downloadingFiles') : $t('message.download')
            }}
          </span>
        </div>
      </v-list-item-title>
      <v-list-item-action style="margin: 0px !important">
        <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>

<script>
// external imports
import _ from 'lodash'

// internal imports
import { BACKUP_DOWNLOADER_SERVER } from '@/config/envs'
import Storage from '@/utils/Storage'
import store from '@/store'

// API
import videosApi from '@/services/videosApi'

export default {
  name: 'MenuItemDownload',
  props: {
    video: {
      type: Object,
      required: true,
    },
    hasRecuo: {
      type: Boolean,
      default: true,
      required: false,
    },
    timeout: {
      type: Number,
      default: 50,
      required: false,
    },
    videoId: {
      type: [Number, String],
      default: '',
      required: true,
    },
    fetchOnMount: {
      type: Boolean,
      default: true,
      required: false,
    },
    value: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data: () => ({
    sizes: [],
    videoSizes: ['240p', '360p', '480p', '720p', '1080p', '1440p', '2160p'],
    availableResolutionsShortened: [],
    storageSizeDetails: {},
    playback: [],
    downloadServer: null,
    authToken: null,
    qualityToBeDownloaded: null,
    loading: false,
    listFetched: false,
    showQualitiesMenu: false,
    position: {
      x: 0,
      y: 0,
    },
  }),
  computed: {
    hasQualityAvailable() {
      const found = _.find(this.sizesList, { available: true })
      return !!found
    },
    sizesList() {
      return [...this.sizes, ...this.extraResolutions]
        .sort((a, b) => {
          const _a = parseInt((a.name ?? a).replace('p', ''))
          const _b = parseInt((b.name ?? b).replace('p', ''))
          return _a - _b
        })
        .map((size) => {
          if (size.name) return { ...size, available: true }
          else return { name: size, available: false }
        })
    },
    extraResolutions() {
      let arr = []
      this.videoSizes.map(
        function (val) {
          let valIndex = this.availableResolutionsShortened.indexOf(val)
          if (valIndex === -1) arr.push(val)
        }.bind(this)
      )
      return arr
    },
  },
  watch: {
    value() {
      this.reset()
    },
    async videoId(value) {
      if (value && this.fetchOnMount) await this.updateList()
    },
  },
  async mounted() {
    if (this.videoId && this.fetchOnMount) await this.updateList()
  },
  methods: {
    handleBackupDownload(hasBackup, e) {
      if (!hasBackup) return this.downloadAlert()
      this.handleDownloadOriginal(hasBackup, e)
    },
    async handleDownloadOriginal(hasBackup, e) {
      if (e) {
        this.position.x = e.clientX
        this.position.y = e.clientY
      }

      if (!this.fetchOnMount && !this.listFetched) {
        this.$emit('input', true)
        return await this.updateList()
      }

      if (hasBackup) return this.downloadVideo()
    },
    downloadAlert() {
      this.$root.$emit('DownloadAlertDialog')
    },
    async downloadVideo() {
      this.qualityToBeDownloaded = null
      let downloadServer = Storage.getItem('downloaderServer')
      if (downloadServer) {
        this.downloadServer = downloadServer
      } else {
        this.downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      setTimeout(() => {
        this.$emit('submit', this.downloadServer)
      }, this.timeout)
    },
    getStandardResolutionValue(value) {
      const [value_1, value_2] = value.split('x')
      const [width, height] = [Number(value_1), Number(value_2)]

      return Math.min(width, height)
    },
    async updateList() {
      this.loading = true

      try {
        const response = await videosApi.getVideoStorageSize(this.videoId)

        this.storageSizeDetails = response.data.storage_size_details

        let availableResolutionsShortened = []
        let numberResolutions = []

        let sizes = Object.keys(this.storageSizeDetails).map((item) => {
          let name

          if (!~item.indexOf('x')) {
            name = item[0].toUpperCase() + item.slice(1)
          } else {
            name = this.getStandardResolutionValue(item)
            numberResolutions.push(Number(name))
            name = name + 'p'
            availableResolutionsShortened.push(name)
          }

          return {
            name,
            value: this.storageSizeDetails[item],
          }
        })

        this.availableResolutionsShortened = availableResolutionsShortened

        this.playback = response.data.playback.filter((playbackQuality) => {
          let indexOfAvailable =
            availableResolutionsShortened.indexOf(playbackQuality)
          if (indexOfAvailable !== -1) return playbackQuality
        })

        sizes.push({
          name: 'Total',
          value: Object.values(this.storageSizeDetails).reduce(
            (previous, current) => previous + current,
            0
          ),
        })
        sizes = sizes.sort((a, b) =>
          Number(a.name.replace('p', '')) < Number(b.name.replace('p', ''))
            ? 1
            : -1
        )
        sizes = sizes.reverse()

        sizes = sizes.filter((obj) => {
          if (
            obj.name !== 'Total' &&
            obj.name !== 'Backup' &&
            obj.name !== 'Images'
          ) {
            return obj
          }

          return false
        })

        sizes = sizes.map((size) => {
          if (this.playback.indexOf(size.name) === -1) {
            size.disabled = true
          }
          return size
        })

        if (this.sizes.length) {
          this.sizes = this.sizes.map((size, index) => {
            const updateObject = sizes[index]
            updateObject.progressTs = size.progressTs
            updateObject.statusTs = size.statusTs
            updateObject.statusM3u8 = size.statusM3u8
            return updateObject
          })
        } else {
          this.sizes = sizes
        }

        this.listFetched = true
        this.showQualitiesMenu = true
        this.$emit('fetched')
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    async handleDownloadQuality({ name }) {
      const qualityToBeDownloaded = name.slice(0, -1)
      const qualitiesFullName = Object.keys(this.storageSizeDetails)
      const qualityToBeDownloadedFullName = qualitiesFullName.filter(
        (quality) => {
          if (quality.indexOf(qualityToBeDownloaded) !== -1) {
            return true
          }
        }
      )[0]
      this.qualityToBeDownloaded = qualityToBeDownloadedFullName
      let downloadServer = Storage.getItem('downloaderServer')
      if (downloadServer) {
        this.downloadServer = downloadServer
      } else {
        this.downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      setTimeout(() => {
        this.$emit('submit', {
          downloadServer: this.downloadServer,
          qualityToBeDownloaded: this.qualityToBeDownloaded,
        })
      }, 1000)
    },
    reset() {
      this.sizes = []
      this.videoSizes = [
        '240p',
        '360p',
        '480p',
        '720p',
        '1080p',
        '1440p',
        '2160p',
      ]
      this.availableResolutionsShortened = []
      this.storageSizeDetails = {}
      this.playback = []
      this.downloadServer = null
      this.authToken = null
      this.qualityToBeDownloaded = null
      this.listFetched = false
    },
  },
}
</script>

<style lang="scss" scoped>
$size: 1.35rem;

.bg-dark {
  .helper {
    &__btn {
      --helper-background-color: rgba(255, 255, 255, 0.54);
      --helper-foreground-color: #000;
    }
  }
}

.helper {
  &__btn {
    --helper-background-color: var(--v-neutral-lighten1);
    --helper-foreground-color: var(--v-neutral-lighten4);

    &::v-deep {
      .v-icon {
        background-color: var(--helper-background-color);
        width: $size;
        height: $size;
        border-radius: 100%;

        &[class*='mdi-'] {
          font-size: $size * 0.8;

          &::before {
            color: var(--helper-foreground-color);
          }
        }
      }
    }
  }
}
</style>
